import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-041cde78")

_pushScopeId("data-v-041cde78")
const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = {
  class: "w-9/12 p-6 overflow-x-scroll whitespace-nowrap frame",
  ref: "horizontalScrollContainer"
}
const _hoisted_3 = {
  class: "flex flex-rowtext-gray-lp-300 pb-1",
  style: {"font-size":"24px"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Total pendapatan bulan ini ")
const _hoisted_5 = {
  class: "\n                ml-5\n                rounded-xl\n                pxpreview\n                serial-3\n                text-shadow text-14px\n                font-medium\n                text-white\n                px-3\n                mb-3\n                bg-red-lp-300\n                text-shadow-active\n              ",
  style: {"border":"0.5px solid #000000"}
}
const _hoisted_6 = { class: "flex flex-row text-xl text-gray-lp-300 relative" }
const _hoisted_7 = { class: "\n                  w-6\n                  h-6\n                  rounded-full\n                  flex\n                  items-center\n                  justify-center\n                  z-20\n                  cursor-pointer\n                " }
const _hoisted_8 = {
  key: 0,
  class: `bg-gray-lp-1300 w-full absolute mt-2 ml-1`
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "flex text-gray-lp-800 mt-10",
  style: {"font-size":"14px"}
}, [
  /*#__PURE__*/_createVNode("p", null, " Ayo tingkatkan pendapatan! Anda agar lebih cuan tiap bulannya! ")
], -1)
const _hoisted_10 = {
  class: "flex",
  style: {"margin-top":"10px"}
}
const _hoisted_11 = { class: "\n                flex\n                text-sm text-gray-lp-800\n                bg-red-lp-1100\n                p-2\n                rounded-lg\n              " }
const _hoisted_12 = {
  class: "ml-2 font-bold text-red-lp-1200",
  style: {"font-size":"12px"}
}
const _hoisted_13 = { class: "w-3/12 relative pt-8 pr-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Card, {
      rounded: "2xl",
      isShadow: false
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("p", null, [
                _hoisted_4,
                _createVNode("strong", null, _toDisplayString(_ctx.formatPrice(_ctx.currentTotal)), 1)
              ]),
              _createVNode("div", _hoisted_5, " Tambahan " + _toDisplayString(_ctx.progress[_ctx.progress.length - 1]?.commissionTierAmount) + "% ", 1)
            ]),
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: `${index}`,
                  style: {"width":"160px","flex-shrink":"0","line-height":"initial"},
                  class: "flex flex-row w-full relative"
                }, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", {
                      class: ["w-6 h-6 rounded-full items-center flex justify-center", 
                    `${
                      _ctx.checkProgressAndScroll(
                        index,
                        _ctx.steps.length,
                        _ctx.progress[index]
                      )
                        ? 'bg-red-lp-300'
                        : 'bg-gray-lp-600'
                    }`
                  ]
                    }, [
                      _createVNode(_component_Icons, {
                        name: _ctx.progress[index] ? 'check' : 'lock',
                        color: "white",
                        width: "12px"
                      }, null, 8, ["name"])
                    ], 2)
                  ]),
                  _createVNode("div", {
                    class: ["mt-8 absolute", 
                  _ctx.progress[index]
                    ? 'font-bold text-gray-lp-300'
                    : 'text-gray-lp-600'
                ],
                    style: {"font-size":"12px"}
                  }, [
                    _createVNode("p", null, "Tambahan " + _toDisplayString(step.bonus) + "%", 1)
                  ], 2),
                  (index < _ctx.steps.length - 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        _createVNode("div", {
                          class: 
                    `${
                      _ctx.progress[index] ? 'bg-red-lp-300' : 'bg-gray-lp-1300'
                    } rounded-full`
                  ,
                          style: 
                    `width: ${
                      _ctx.progress[index] && _ctx.progress[index + 1] ? '100%' : `0%`
                    };height: 10px`
                  
                        }, null, 6)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _hoisted_9,
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_Icons, {
                  name: "clock",
                  color: "#e40101",
                  width: "18px"
                }),
                _createVNode("p", _hoisted_12, " Tersisa " + _toDisplayString(_ctx.countDown) + " hari lagi untuk bulan ini ", 1)
              ])
            ])
          ], 512),
          _createVNode("div", _hoisted_13, [
            _createVNode("img", {
              src: 
              require(`@/app/ui/assets/images/progressive-commission/progress-commission.png`)
            ,
              alt: "progress-commission",
              class: "bottom-0 right-0 m-auto"
            }, null, 8, ["src"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
})